import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { Field } from 'react-final-form'
import { FieldArray } from 'react-final-form-arrays'
import { path, map } from 'ramda'
import {
  Table,
  TableRow,
  TableCol,
  TableHeader,
  TableBody, TableColRight
} from 'components/Table'
import { TFeeItem } from 'types'
import { Tag } from 'components/StyledElems'
import { ApprovalStatus } from 'components/UI'
import dateFormat from 'utils/dateFormat'
import numberFormat from 'utils/numberFormat'
import { InputField, CheckboxField } from 'components/Form'

type Props = {
  list: TFeeItem[];
  showType?: boolean;
  rejectMode?: boolean;
  typeModal?: string;
}
const HeaderRow = styled(TableRow)`
 label {
  opacity: 0.6;
  pointer-events: none;
 }
`
const InputFieldUI = styled(InputField)`
    height: 32px;
    border-radius: 4px;
    font-size: 13px;
    padding: 0 10px;
`

const ExpenseRejectListField: FunctionComponent<Props> = props => {
  const { list, showType, rejectMode, typeModal } = props

  const ids = map(path<number>(['id']), list)

  return (
    <FieldArray
      defaultValue={list}
      name={typeModal}
      render={({ fields }) => {
        const header = rejectMode
          ? (
            <HeaderRow align="center">
              <TableCol span={1} />
              <TableCol span={4}>Date</TableCol>
              <TableCol span={3} />
              <TableCol span={6}>Description</TableCol>
              <TableColRight span={3}>Cost</TableColRight>
              <TableCol span={7}>Comment</TableCol>
            </HeaderRow>
          )
          : (
            <HeaderRow align="center">
              <TableCol span={1} />
              <TableCol span={7}>Date</TableCol>
              <TableCol span={5} />
              <TableCol span={8}>Description</TableCol>
              <TableColRight span={4}>Cost</TableColRight>
            </HeaderRow>
          )
        return (
          <div>
            <Table gutter={20} list={ids}>
              <TableHeader>
                {header}
              </TableHeader>
              <TableBody>
                {fields.map((field, index) => {
                  const fee = fields.value[index]
                  const currency = path(['assignment', 'currency', 'name'], fee)
                  const amount = numberFormat(fee.amount, currency)

                  const body = rejectMode
                    ? (
                      <TableRow align="center" key={index}>
                        <TableCol span={1}>
                          <Field
                            name={`${field}.${typeModal === 'expenses' ? 'expenses' : 'fees'}`}
                            component={CheckboxField}
                          />
                        </TableCol>
                        <TableCol span={4}>{dateFormat(fee.date)}</TableCol>
                        <TableCol span={3}>
                          {showType && <Tag>Expense</Tag>}
                          <ApprovalStatus>{fee.statusApprovement}</ApprovalStatus>
                        </TableCol>
                        <TableCol span={6}>{fee.description}</TableCol>
                        <TableColRight span={3}>{amount}</TableColRight>
                        <TableColRight span={7}>
                          <Field
                            name={`${field}.comment`}
                            component={InputFieldUI}
                          />
                        </TableColRight>
                      </TableRow>
                    )
                    : (
                      <TableRow align="center" key={index}>
                        <TableCol span={1}>
                          <Field
                            name={`${field}.${typeModal === 'expenses' ? 'expenses' : 'fees'}`}
                            component={CheckboxField}
                          />
                        </TableCol>
                        <TableCol span={7}>{dateFormat(fee.date)}</TableCol>
                        <TableCol span={5}>
                          {showType && <Tag>Fee</Tag>}
                          <ApprovalStatus>{fee.statusApprovement}</ApprovalStatus>
                        </TableCol>
                        <TableCol span={8}>{fee.description}</TableCol>
                        <TableColRight span={4}>{amount}</TableColRight>
                      </TableRow>
                    )
                  return body
                })}

              </TableBody>
            </Table>
          </div>
        )
      }}
    />

  )
}
ExpenseRejectListField.defaultProps = {
  showType: false,
  typeModal: 'fees'
}
export default ExpenseRejectListField
